import { createAction, props } from '@ngrx/store';
import { IRevenue } from 'src/app/shared/interfaces/revenue/irevenue';

enum RevenueActionType {
  LOAD_REVENUE = '[revenue] load revenue from api',
  LOAD_REVENUE_SUCCESS = '[revenue] load revenue from api return success',
  LOAD_REVENUE_ERROR = '[revenue] load revenue from api return error',
  SAVE_REVENUE = '[revenue] save revenue from api',
  SAVE_REVENUE_SUCCESS = '[revenue] edit revenue from api return success',
  INACTIVATE_REVENUE = '[revenue] inactivate revenue from api',
  ACTIVATE_REVENUE = '[revenue] activate revenue from api',
}

export const loadRevenue = createAction(RevenueActionType.LOAD_REVENUE);
export const loadRevenueSuccess = createAction(
  RevenueActionType.LOAD_REVENUE_SUCCESS,
  props<{ lista: IRevenue[] }>()
);
//vai para o effects
export const saveRevenue = createAction(
  RevenueActionType.SAVE_REVENUE,
  props<{ revenue: IRevenue }>()
);
//vai para o reducer
export const saveRevenueSuccess = createAction(
  RevenueActionType.SAVE_REVENUE_SUCCESS,
  props<{ revenue: IRevenue }>()
);

export const inactivateRevenue = createAction(
  RevenueActionType.INACTIVATE_REVENUE,
  props<{ id: number }>()
);

export const activateRevenue = createAction(
  RevenueActionType.ACTIVATE_REVENUE,
  props<{ id: number }>()
);
